<script setup>
import { computed } from 'vue';
import SalesOverviewPending from './SalesOverviewPending.vue';
import SalesOverviewRecent from './SalesOverviewRecent.vue';
import SalesOverviewTotals from './SalesOverviewTotals.vue';
import SalesOverviewWelcome from './SalesOverviewWelcome.vue';

const props = defineProps({
  firstName: { type: String, default: '' },
  dashboard: {
    type: Object,
    default: () => ({
      counts: {},
      recent: [],
      recent_list: 'rascunhos',
      recent_total: 0,
      pending: [],
    }),
  },
  loading: { type: Boolean, default: false },
  recentLoading: { type: Boolean, default: false },
  now: { type: [Date, String, Number], default: () => new Date() },
  updatedAt: { type: [Date, String, Number], default: null },
});

const emit = defineEmits([
  'open',
  'openRecent',
  'openPendingCharge',
  'selectList',
  'recentListChange',
  'refresh',
]);

const hasPendingRows = computed(
  () =>
    (props.dashboard.pending?.length || 0) +
      (props.dashboard.pending_charges?.length || 0) >
    0
);
</script>

<template>
  <section class="grid min-w-0 gap-4">
    <SalesOverviewWelcome
      :first-name="firstName"
      :now="now"
      :loading="loading || recentLoading"
      :updated-at="updatedAt"
      @refresh="emit('refresh')"
    />
    <div
      class="grid min-w-0 gap-4 xl:grid-cols-[minmax(0,2fr)_minmax(300px,1fr)]"
    >
      <div data-testid="sales-overview-main-column" class="grid min-w-0 gap-4">
        <SalesOverviewPending
          v-if="hasPendingRows"
          :dashboard="dashboard"
          :loading="loading || recentLoading"
          @open="emit('open', $event)"
          @open-pending-charge="emit('openPendingCharge', $event)"
        />
        <SalesOverviewRecent
          :dashboard="dashboard"
          :loading="loading"
          @open-recent="emit('openRecent', $event)"
          @select-list="emit('selectList', $event)"
          @recent-list-change="emit('recentListChange', $event)"
        />
      </div>
      <div data-testid="sales-overview-summary-column" class="min-w-0">
        <SalesOverviewTotals :counts="dashboard.counts" :loading="loading" />
      </div>
    </div>
  </section>
</template>
